import React from "react";
import ProgressLoader from "../../ProgressLoader";
import AudioPlayer from "react-h5-audio-player";
import {
  ChatAudioRecorderHoc,
  ChatAudioSender2Hoc,
} from "../../../../../../assets/images";
import "../../../../../../assets/scss/audioplayer.scss";
import "../../../../../../assets/scss/audioplayerstyles.scss";
import {
  isBlobUrl,
} from "../../../../../../Helpers/Utility";
import SDK from "../../../../../../SDK";

const AudioComponent = (props = {}) => {
  const {
    messageObject = {},
    uploadStatus,
    isSender,
    audioFileDownloadOnclick,
    mediaUrl = "",
  } = props;
  const {
    msgId = "",
    msgBody: { media: { file_url = "", audioType = "", file_key } = {} } = {},
  } = messageObject;

  const [isPlaying, setPlaying] = React.useState(false);
  const [audioUrl, setAudioUrl] = React.useState(mediaUrl);

  const getAudio = async () => {
    await SDK.getMediaURL(file_url, file_key)
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob?.data.blob);
        setAudioUrl(blobUrl);
      })
      .catch((e) => {
        console.log("AudioUrlFailed", e);
      });
  };

  React.useEffect(() => {
    if (mediaUrl !== "") return setAudioUrl(mediaUrl);
    if (isBlobUrl(file_url)) return setAudioUrl(mediaUrl);
    if (mediaUrl === "" && audioUrl === "") getAudio();
  }, [mediaUrl, msgId]);

  const handleOnPlayEnd = (e) => {
    e.target.play();
    setTimeout(() => e.target.pause(), 10);
  };

  const handleOnPlay = (e = {}) => {
    setTimeout(() => setPlaying(true), 0);
    document &&
      document
        .querySelectorAll("audio")
        .forEach((element) =>
          element.src !== e.srcElement.currentSrc
            ? element.pause()
            : element.play()
        );
  };

  return (
    <>
      <div
        className={`audio-message-container
          ${uploadStatus !== 2 || audioUrl === "" ? "fileProgress" : ""}
          ${isPlaying ? "isPlaying" : ""}`}
      >
        {audioType !== "recording" ? (
          <i className="audio">
            <ChatAudioSender2Hoc viewBox="0 0 35 35" />
          </i>
        ) : (
          <i className="audio recording">{<ChatAudioRecorderHoc viewBox="0 0 13.249 19.873"/>}</i>
        )}

        <ProgressLoader
          msgId={msgId}
          isSender={isSender}
          file_url={file_url}
          imgFileDownloadOnclick={audioFileDownloadOnclick}
          uploadStatus={audioUrl === "" ? 1 : uploadStatus}
        />
        <AudioPlayer
          src={uploadStatus === 1 ? "" : audioUrl}
          autoPlay={false}
          autoPlayAfterSrcChange={false}
          showLoopControl={false}
          showSkipControls={false}
          showJumpControls={false}
          showVolumeControl={false}
          onPlayError={(e) => console.log("handleOnPlayError", e)}
          onEnded={(e) => handleOnPlayEnd(e)}
          onPause={() => setPlaying(false)}
          onPlay={(e) => handleOnPlay(e)}
          onSeeking={(e) => handleOnPlay(e)}
        />
      </div>
      <div className="image-caption">
        <span></span>
      </div>
    </>
  );
};

export default AudioComponent;
